export const BASE_AUTH_API_URL = process.env.REACT_APP_BASE_AUTH_URL_API;
export const BASE_USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const BASE_SHAREPOINT_API_URL = process.env.REACT_APP_SHAREPOINT_API_URL;
export const BASE_VEHICULE_API_URL = process.env.REACT_APP_VEHICULE_API_URL;
export const BASE_USER_URL = `${BASE_USERS_API_URL}/users`;
export const API_KEY_MAPS = process.env.REACT_APP_API_KEY_MAPS;
export const STRAPI_API_URL = process.env.REACT_APP_STRAPI_API_URL;
export const SINISTER_API_URL = process.env.REACT_APP_SINISTER_API_URL;
